import React from 'react'
import styled , {css} from 'styled-components';
import connect from '../../../js_bytesize/config/purchase/connect';
import { device } from '../../utils/responsive_utilities';
import { titanWhite, white, codGrey} from '../../components/loggedout/shared-styles/Colors';
import Image from '../loggedout/common/Image';
import MoneyBackImg from '../liveClassPurchasePage/Pages/PlanPage/money-back.svg';
import { deviceBreakPoints } from '../liveClassPurchasePage/breakpoints';
import FontGraphie from '../loggedout/shared-styles/graphieFont';

const MoneyBackStrip = (props) => {
  const getTrialEndDate = () => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let curr_date = new Date();
    let timeStampOfTrialEnd = curr_date.setDate(curr_date.getDate() + 30);
    let trialEndDate = new Date(timeStampOfTrialEnd);
    return `${months[trialEndDate.getMonth()]} ${trialEndDate.getDate()}, ${trialEndDate.getFullYear()}`
  }
  return (  
    <MoneyBackWidget {...props}>
      <Image src={MoneyBackImg} />
      <span>30 days Money-back guarantee</span>
      <InfoIcon iIconColor={props.iIconColor} fromSummayPage={props.fromSummayPage}>i</InfoIcon>
      <ToolTip bgColor={props.bgColor} textColor={props.textColor} toolTipColor={props.toolTipColor} left={props.left} fromSummayPage={props.fromSummayPage}>
        <p>If you’re not satisfied with SplashLearn within 30 days, i.e. till {getTrialEndDate()}, you can avail a full hassle free refund.</p>
      </ToolTip>
    </MoneyBackWidget>
  )
}
export const MoneyBackWidget = styled.div`
  background-color: ${(props) => props.bgColor};
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  position: relative;
  margin: 2rem auto;
  height: 3rem;
  display: flex;
  width: 30rem;
  @media ${device.PhoneLargeScreen} {
    width: 28.4rem;
  }
  @media ${device.Phone} {
    width: 28.4rem;
  }
  &:hover {
    div {
      display: block;
    }
  }
  img {
    position: absolute;
    width: 5rem;
    left: 0;
    top: -0.9rem;
    @media ${device.PhoneLargeScreen} {
      width: 4.3rem;
      top: -0.4rem;
    }
    @media ${device.Phone} {
      width: 4.3rem;
      top: -0.4rem;
    }
    ${(props) =>
      props.fromSummayPage
        ? css`
            @media ${deviceBreakPoints.IpadPortrait} {
              left: -0.3rem;
            }
          `
        : ''};
  }
  span {
    ${FontGraphie(1.4, 1.8, 7)};
    color: ${(props) => props.fColor};
    margin-left: 1.5rem;
  }
  ${(props) =>
    props.fromSummayPage
      ? css`
          @media ${deviceBreakPoints.IpadPortrait} {
            width: 26rem;
            span {
              ${FontGraphie(1.2, 1.8, 7)};
            }
          }
        `
      : ''};
`;
const ToolTip = styled.div`
  border: 0.2rem solid ${props=>props.bgColor};
  box-sizing: border-box;
  background-color: ${props=>props.toolTipColor || white};
  border-radius: 1rem;
  position: absolute;
  padding: 1.5rem;
  display: none;
  width: 37rem;
  z-index: 10;
  left: ${props=>props.left ? '-3rem' : '22rem'};
  top: 4.5rem;
  > P {
    ${FontGraphie(1.2, 1.6, 5)};
    color: ${props=>props.textColor ? titanWhite : codGrey};
    opacity: ${props=>props.textColor ? 1 : 0.5};
  }
  &:after {
    content: ' ';
    position: absolute;
    border: 1.6rem solid;
    border-color: transparent transparent ${props=>props.toolTipColor || white} transparent;
    top: -2.8rem;
    left: ${props=>props.left ? '29.5rem' : '4rem'};
    border-radius: 0.5rem;
  }
  &:before {
    content: ' ';
    position: absolute;
    border: 1.6rem solid;
    border-color: transparent transparent ${props=>props.bgColor} transparent;
    top: -3.2rem;
    left: ${props=>props.left ? '29.5rem' : '4rem'};
    border-radius: 0.5rem;
  }
  @media ${device.PhoneLargeScreen} {
    width: 30.2rem;
    left: 0;
    &:after {
      right: 2rem;
      left: auto;
    }
    &:before {
      right: 2rem;
      left: auto;
    }
  }
  @media ${device.Phone} {
    width: 30.2rem;
    left: 0;
    &:after {
      right: 2rem;
      left: auto;
    }
    &:before {
      right: 2rem;
      left: auto;
    }
  }
  ${(props) =>
    props.fromSummayPage
      ? css`
          @media ${deviceBreakPoints.IpadPortrait} {
            left: ${props=>props.left ? '0rem' : '22rem'};
            width: 26rem;
            &:after {
              right: -0.1rem;
              left: auto;
            }
            &:before {
              right: -0.1rem;
              left: auto;
            }
          }
        `
      : ''};
`;
const InfoIcon = styled.i`
  color: ${white};
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.8rem;
  height: 1.8rem;
  ${FontGraphie(1.8, 2.2, 7)};
  background: ${props=>props.iIconColor};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 0.2rem 0 rgb(0 0 0 / 25%);
  @media ${device.PhoneLargeScreen} {
      width: 1.5rem;
      height: 1.5rem;
      ${FontGraphie(1.4, 2.0, 7)};
    }
    @media ${device.Phone} {
      width: 1.5rem;
      height: 1.5rem;
      ${FontGraphie(1.4, 2.0, 7)};
    }
    ${(props) =>
      props.fromSummayPage
        ? css`
            @media ${deviceBreakPoints.IpadPortrait} {
              right: 0.5rem;
            }
          `
        : ''};
`;
function mapStateToProps(state) {
  return {
    settings: state.settings,
  }
}
export default connect(mapStateToProps, null, MoneyBackStrip);